var SpotModel = require("../models/SpotModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

var exceptionHandler = require('../helpers/ExceptionHandler');

/**
 * 
 * @param {QueueModel} viewModel
 * @param {() => string} userLanguage
 */

function SpotsWS(viewModel, userLanguage) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.spots = ko.observableArray([]);
  self.name = 'SpotsWS';
  self.userLanguage = userLanguage;


	/**
	 * Defines the string to request API services
	 *
	 * @method serviceURL
	 * @returns {String}
	 */
  self.serviceURL = ko.computed(
    function () {
      var queryString = '?locale=' + self.userLanguage();
      return (
        "/qless/api/v1/employee/queues/" + self.parent.id + "/spots/waiting" + queryString
      );
    },
    self,
    { deferEvaluation: true }
  );

	/**
	 * Overload to prevent service from being called before the QueueID has
   * been set
	 *
	 * @method
	 * @param
	 * @returns
	 */
  self.doRequest = function (fCallback) {
    if (self.parent.id !== -1) {
      AbstractWS.prototype.doRequest.call(self, fCallback);
    }
  };


	/**
	 * Locates a SpotModel instance by the session id
	 *
	 * @method getSpotBySessionId
	 * @param {String} sSessionId
	 * @returns {SpotModel | Null}
	 */
  self.getSpotBySessionId = function (sSessionId) {
    return self.spots().filter(function (spot) {
      return (spot.sessionId == sSessionId);
    })[0];
  };


	/**
	 * Returns the total number of people in line, accounting for party size
	 *
	 * @method getTotalPartySize
	 * @returns {Number}
	 */
  self.getTotalPartySize = function () {
    var total = self.spots.reduce(function (count, spot) {
      var size = spot.getAttribute('partySize');
      if (size != '' || size != null) {
        count++;
      }
      else {
        count += Number(size);
      }

      return count;
    }, 0);

    return total;
  };


	/**
	 * This method iterates over the data returned from the service and
	 * converts the individual nodes into LocationModels and then assigns
	 * them to this object's locations collection.
	 *
	 * @method processData
	 * @param {XMLString} xmlData XML data returned from the service
	 * @returns {LocationsWS} Returns the object as chainable, for best practice
	 */
  self.processData = function (xmlData) {
    var aTemp = [];

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);

    if (json && !json.error) {
      var aSpots = Array.makeArray(json.queueSpots.spot);

      aSpots.forEach(function (spot) {
        aTemp.push(new SpotModel(spot));
      });

      self.spots(aTemp);

      try {
        self.parent.updateVariances();
      }
      catch (error) {
        exceptionHandler.processException(error);
      }
    }

    return self;
  };


	/**
	 * Removes a Consumer from the Queue visually
	 *
	 * @method removeSpot
	 * @param {String} sSessionId
	 * @returns none
	 */
  self.removeSpot = function (sSessionId) {
    var tSpots = self.spots().filter(function (spot) {
      return spot.sessionId != sSessionId;
    });

    self.spots(tSpots);
  };


	/**
	 * Returns the object to it's initial state
	 *
	 * @method reset
	 * @returns none
	 */
  self.reset = function () {
    // Remove any spots
    self.spots.removeAll();
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.reset.call(self);
  };

  return self;
};

SpotsWS.prototype = Object.create(AbstractWS.prototype);
SpotsWS.prototype.constructor = SpotsWS;

module.exports = SpotsWS;
